import { render, staticRenderFns } from "./OrderCheck.vue?vue&type=template&id=1856676d"
import script from "./OrderCheck.vue?vue&type=script&lang=js"
export * from "./OrderCheck.vue?vue&type=script&lang=js"
import style0 from "./OrderCheck.vue?vue&type=style&index=0&id=1856676d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports